<template>
  <!-- "What's new" popup. Shown once per login during the announcement window (SHOW_FROM / SHOW_DAYS);
       closing it, or opening the new section, hides it for the rest of that login. -->
  <v-dialog v-model="open" max-width="520" persistent>
    <v-card class="whats-new">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="me-2">mdi-chart-box-outline</v-icon>
        <span class="text-h6 font-weight-bold">{{ $t("root.whatsNewReportsTitle") }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small :aria-label="$t('root.dismiss')" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-2">
        <p class="mb-3">{{ $t("root.whatsNewReportsIntro") }}</p>
        <ul class="whats-new__list">
          <li>{{ $t("root.whatsNewReportsPoint1") }}</li>
          <li>{{ $t("root.whatsNewReportsPoint2") }}</li>
          <li>{{ $t("root.whatsNewReportsPoint3") }}</li>
        </ul>
      </v-card-text>
      <v-card-actions class="px-6 pb-5">
        <v-spacer></v-spacer>
        <v-btn text class="text-capitalize" @click="close">{{ $t("root.whatsNewGotIt") }}</v-btn>
        <v-btn color="primary" depressed class="text-capitalize" @click="explore">{{ $t("root.whatsNewExplore") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Shown at every login from SHOW_FROM for SHOW_DAYS days (the release day counts as day 1), then never again.
// To announce something new, change these two values and the text under root.whatsNewReports*.
const SHOW_FROM = "2026-10-28";
const SHOW_DAYS = 2;
const STORAGE_KEY = "WHATS_NEW_LAST_LOGIN";

const inWindow = () => {
  const start = new Date(SHOW_FROM + "T00:00:00");
  const end = new Date(start.getTime());
  end.setDate(end.getDate() + SHOW_DAYS);
  const now = new Date();
  return now >= start && now < end;
};

// A new login issues a new token, so "this login" is identified by the end of the stored login token.
const loginId = () => {
  try {
    const token = localStorage.getItem("apollo-done-token") || "";
    return token ? token.slice(-24) : "";
  } catch (e) {
    return "";
  }
};

const seenThisLogin = id => {
  try {
    return localStorage.getItem(STORAGE_KEY) === id;
  } catch (e) {
    return false;
  }
};

const markSeen = id => {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch (e) {
    // storage blocked: the popup may show again on reload, nothing else breaks
  }
};

export default {
  name: "WhatsNewDialog",
  data() {
    return { open: false };
  },
  mounted() {
    // small delay so it appears after the page has settled, not over the loading state
    this.timer = setTimeout(() => {
      const id = loginId();
      this.open = !!id && inWindow() && !seenThisLogin(id);
    }, 1200);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    close() {
      markSeen(loginId());
      this.open = false;
    },
    explore() {
      this.close();
      if (this.$route.path !== "/reports") this.$router.push("/reports").catch(() => {});
    },
  },
};
</script>

<style scoped>
.whats-new__list {
  padding-inline-start: 20px;
}
.whats-new__list li {
  margin-bottom: 8px;
}
</style>
